// Helper to perform AJAX requests
class Axios {
    /**
     * Create a new API instance.
     *
     * @param {object} data
     */
    constructor(url) {
        this.axios = axios.create({
            baseURL: url,
            timeout: 600000,
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            validateStatus: function (status) {
                return status >= 200 && status < 500; // Override default action of rejecting 400's.
            }
        });

        if (authToken) {
            if (url === '/restv3' && jwtToken) this.axios.defaults.headers.common['authorization'] = `Bearer ${jwtToken}`;
            else this.axios.defaults.headers.common['Auth'] = authToken;
        }
        this.active = false;

    }

    callApi(method, path, data, options) {
        if (options && options.Authorization) {
            this.axios.defaults.headers.common['Authorization'] = options.Authorization;
        }

        // look for additional query strings
        if (options && options.query) {
            let urlSplit = this.getUrlParams(path);
            let searchParams = urlSplit.params;
            for (const key in options.query) {
                const value = options.query[key]
                searchParams[key] = value;
            }
            path = urlSplit.url + '?' + (Object.keys(searchParams).map((key) => key + '=' + searchParams[key]).join('&'));
        }

        return new Promise((resolve, reject) => {
            this.axios[method](path, data)
                .then(response => {
                    return resolve(response);
                })
                .catch(error => {
                    console.log(error);
                    return reject(error);
                });
        })
    }

    get(path, options) {
        // console.log(path, options)
        return this.callApi('get', path, undefined, options)
    }

    post(path, data, options) {
        return this.callApi('post', path, data, options)
    }

    put(path, data, options) {
        return this.callApi('put', path, data, options)
    }

    patch(path, data, options) {
        return this.callApi('patch', path, data, options)
    }

    delete(path, options) {
        return this.callApi('delete', path, undefined, options)
    }

    options(path, options) {
        return this.callApi('options', path, undefined, options)
    }

    addQueue(method, path) {
        this.queue.push(function () { return api[method](path); });
        // console.log('Queue: ' + this.queue);
        return this.queue;
    }

    viewQueue() {
        return this.queue;
    }

    all(queue) {
        return new Promise((resolve, reject) => {
            var q = function () { for (let i = 0; i < queue; i++) { queue[i]() } };
            axios.all([q])
                .then(response => {
                    // console.log('Reponse');
                    // console.log(response);
                    resolve(response.data);
                })
                .catch(error => {
                    console.log('Reject');
                    console.log(error);
                    reject(error.data);
                });
        });
    }

    getAllPages(endpoint = '/', options = null, paginate = false) {
        return new Promise((resolve, reject) => {
            // Get at least page one.
            let pages = 1
            this.get(endpoint, options)
                .then((response) => {
                    // console.log(response)
                    if (!response) return reject('No Data')

                    // Not authorized
                    if (response.status === 400 || response.status === 403) {
                        return reject(response)

                    // 500 or other unknown error
                    } else if (response.status !== 200) {
                        return reject(response)

                    // This means this is the last page.  Calc pages appropriately
                    } else if (response.data && response.data.previous && !response.data.next) {
                        pages = parseInt(response.data.previous.split('page=')[1], 10) + 1
                        response.data.pages = pages // add pages property

                    // This means more than one page of data. We'll get pages by queueing up all requests.
                    } else if (response.data && response.data.next) {
                        pages = Math.ceil((parseInt(response.data.count, 10) / response.data.results.length))
                        response.data.pages = pages // add pages property

                    // This means only that one page was found.
                    } else if (response.data && typeof response.data === 'object') {
                        response.data.pages = pages // add pages property
                        return resolve(response)

                    // Shouldn't be here, but we'll put something here as a placeholder
                    } else {
                        console.log('Unknown response')
                        return resolve(response)
                    }

                    // Return data if we want only the current page
                    if (paginate) {
                        return resolve(response)
                    }

                    // If here, we want to send all the results at once.  Useful for setup codes, e.g. productions
                    // Now build up number of additional pages to request, but skip page one since we already have it
                    // Only a few requests are kept in flight at once. Firing every page together
                    // (90-120 pages on big lists) saturates the backend and makes each request wait.
                    const MAX_CONCURRENT = 8
                    const responses = new Array(Math.max(pages - 1, 0))
                    let nextPage = 2
                    const worker = async () => {
                        while (nextPage <= pages) {
                            const page = nextPage++
                            const curOptions = Object.assign({ query: { page } }, options)
                            responses[page - 2] = await this.get(endpoint, curOptions)
                        }
                    }
                    const queue = []
                    for (let i = 0; i < Math.min(MAX_CONCURRENT, pages - 1); i++) queue.push(worker())

                    // Now get remaining pages; responses stay in page order
                    Promise.all(queue)
                        .then(() => {
                            // Now add to original record:
                            responses.map((res) => {
                                if (res && res.status === 200 && res.data) {
                                    res.data.results.map((record) => response.data.results.push(record))
                                }
                            })

                            return resolve(response)
                        })
                        .catch(error => {
                            console.log(error)
                            return reject(error)
                        })
                })
        })
    }

    getUrlParams(url) {
        const urlSplit = url.split('?');
        const u = urlSplit[0];
        const q = urlSplit[1];
        const paramArr = q.split('&');
        const result = { url: u, params: {} };
        paramArr.map((param) => {
            const [key, val] = param.split('=');
            result.params[key] = decodeURIComponent(val);
        })
        return result;
    }
}

export default Axios;